export const AddIcon = () => (
  <svg viewBox='0 0 32 32' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 16H29' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    <path d='M16 4L16 29' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
  </svg>
)
